import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import '@/styles/index.scss' // global css
// import '@/styles/layout.css'
// import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import './icons' // icon

import './plugins/axios'
import './plugins/element.js'
import './plugins/common.js'
import './plugins/moment.js'
import './plugins/permission.js'
import './directives'
import './components'
import './plugins/echarts'
import './plugins/guide'
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css';
import './utils/dialog'

import jquery from 'jquery'
window.jquery = window.$ = jquery

import 'babel-polyfill';
import { Button,Popup,Picker,Icon,Overlay,Swipe, SwipeItem,ActionSheet,Cell,TreeSelect,Dialog } from 'vant'
import VueAwesomeSwiper from 'vue-awesome-swiper'
 
import VueClipboard from 'vue-clipboard2'

// import style
// import 'swiper/css/swiper.css'
import 'swiper/swiper-bundle.css'
import Meta from 'vue-meta'
import {VueJsonp} from 'vue-jsonp'
Vue.use(Meta)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(VueClipboard)
Vue.use(VueJsonp)

Vue.use(Popup).use(Button).use(Picker).use(Icon).use(Overlay).use(Swipe).use(SwipeItem).use(ActionSheet).use(Cell).use(TreeSelect).use(Dialog).use(Share)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')